import React from 'react';
import { Modal, Button } from 'react-bootstrap';

class HelpRequiredPopup extends React.PureComponent {
    render() {
        return (
            <Modal show={this.props.show}
                onHide={this.props.handleClose}
                className="wbm-modal contact-us-modal md"
            >
                <Modal.Header closeLabel='Ok'>
                    <h3 className="wbmblue centered-block">Help Required</h3>
                </Modal.Header>
                <Modal.Body>
                    We're sorry, you currently do not have this feature active. 
                    <br/>
                    Please contact your {this.props.CSRRepTitle} for assistance.
                    <div>
                        <Button
                            className="btn btn-primary btn-square"
                            onClick={this.props.handleClose}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
export default HelpRequiredPopup;
